module.exports = __webpack_public_path__ + "static/media/learningsolutions.933bd548.png";